import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { CommunityProfileType } from '@models';

import { AuthenticationService, UserBeanService, i18nService } from '@services';

export const i18nResolver: ResolveFn<string> = () => {
  const authentication = inject(AuthenticationService);
  const i18n = inject(i18nService);

  return authentication
    .getSystemSettings()
    .then((settings) => i18n.getLocale(settings));
};

export const storedLocaleResolver: ResolveFn<string> = () =>
  inject(i18nService).getLocale();

export const i18nWithProjectRoomRedirectResolver: ResolveFn<void> = async ({
  queryParams,
}) => {
  const authentication = inject(AuthenticationService);
  const userBeanService = inject(UserBeanService);
  const router = inject(Router);
  const i18n = inject(i18nService);

  const userBean = await userBeanService.getUserBean();

  if (userBean.communityProfileId === CommunityProfileType.SIGNING_ROOM) {
    return new RedirectCommand(
      router.createUrlTree(['/home'], { queryParams })
    );
  }

  authentication.getSystemSettings().then((settings) => {
    i18n.getLocale(settings);
  });

  return undefined;
};
